import { ICON_FILL } from "utils/constant/STYLE";

export const ICONS = {
  LOGO: "Logo",
  PLUS: "Plus",
  OPTIONS: "Options",
  SHARE: "Share",
  NOTI_OFF: "NotiOff",

  WORST_CASE: "WorstCase",
  CLOSE: "Close",
  SEARCH: "Search",
  MENU: "Menu",
  HOME: "Home",

  BEST_CASE: "BestCase",
  GRADE: "Grade",
  NOTI_ON: "NotiOn",
  PIE_CHART: "PieChart",
  ARROW_FORWARD: "ArrowForward",

  LINE: "Line",
  BACK: "Back",
  FORWARD: "Forward",
  EXPAND: "Expand",
  COLLAPSE: "Collapse",

  CANDLE: "Candle",
  UP: "Up",
  DOWN: "Down",
  EXPAND_ALL: "ExpandAll",
  CHECK: "Check",

  CANCEL: "Cancel",
  TEXT_VALUE: "TextValue",
  RADIO_BUTTON_CHECKED: "RadioButtonChecked",
  AI: "Ai",

  HELP: "Help",
  HELPLINE: "HelpLine",
  RADIO_BUTTON_UNCHECKED: "RadioButtonUnchecked",

  CHECK_LINE: "CheckLine",
  CHECK_FILL: "CheckFill",
  ADD_CIRCLE: "AddCircle",
  AUTORENEW: "Autorenew",

  ADD_NOTI: "AddNoti",

  SECURE: "Secure",

  ADD: "Add",
  PORTFOLIO: "Portfolio",
  SETTING: "Setting",

  CIRCLE: "Circle",
  CONTENT_COPY: "ContentCopy",
};

const Logo = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M10.5 13H4.25C3.89583 13 3.59896 12.8802 3.35938 12.6406C3.11979 12.401 3 12.1042 3 11.75C3 11.3958 3.11979 11.099 3.35938 10.8594C3.59896 10.6198 3.89583 10.5 4.25 10.5H10.5V4.25C10.5 3.89583 10.6198 3.59896 10.8594 3.35938C11.099 3.11979 11.3958 3 11.75 3C12.1042 3 12.401 3.11979 12.6406 3.35938C12.8802 3.59896 13 3.89583 13 4.25V10.5H19.25C19.6042 10.5 19.901 10.6198 20.1406 10.8594C20.3802 11.099 20.5 11.3958 20.5 11.75C20.5 12.1042 20.3802 12.401 20.1406 12.6406C19.901 12.8802 19.6042 13 19.25 13H13V19.25C13 19.6042 12.8802 19.901 12.6406 20.1406C12.401 20.3802 12.1042 20.5 11.75 20.5C11.3958 20.5 11.099 20.3802 10.8594 20.1406C10.6198 19.901 10.5 19.6042 10.5 19.25V13Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Plus = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M10.5 13H4.25C3.89583 13 3.59896 12.8802 3.35938 12.6406C3.11979 12.401 3 12.1042 3 11.75C3 11.3958 3.11979 11.099 3.35938 10.8594C3.59896 10.6198 3.89583 10.5 4.25 10.5H10.5V4.25C10.5 3.89583 10.6198 3.59896 10.8594 3.35938C11.099 3.11979 11.3958 3 11.75 3C12.1042 3 12.401 3.11979 12.6406 3.35938C12.8802 3.59896 13 3.89583 13 4.25V10.5H19.25C19.6042 10.5 19.901 10.6198 20.1406 10.8594C20.3802 11.099 20.5 11.3958 20.5 11.75C20.5 12.1042 20.3802 12.401 20.1406 12.6406C19.901 12.8802 19.6042 13 19.25 13H13V19.25C13 19.6042 12.8802 19.901 12.6406 20.1406C12.401 20.3802 12.1042 20.5 11.75 20.5C11.3958 20.5 11.099 20.3802 10.8594 20.1406C10.6198 19.901 10.5 19.6042 10.5 19.25V13Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Options = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        d="M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Share = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M6 19.575C5.45 19.575 4.97917 19.3792 4.5875 18.9875C4.19583 18.5958 4 18.125 4 17.575V15.575C4 15.2917 4.09583 15.0542 4.2875 14.8625C4.47917 14.6708 4.71667 14.575 5 14.575C5.28333 14.575 5.52083 14.6708 5.7125 14.8625C5.90417 15.0542 6 15.2917 6 15.575V17.575H18V15.575C18 15.2917 18.0958 15.0542 18.2875 14.8625C18.4792 14.6708 18.7167 14.575 19 14.575C19.2833 14.575 19.5208 14.6708 19.7125 14.8625C19.9042 15.0542 20 15.2917 20 15.575V17.575C20 18.125 19.8042 18.5958 19.4125 18.9875C19.0208 19.3792 18.55 19.575 18 19.575H6ZM11 7.425L9.125 9.3C8.925 9.5 8.6875 9.59583 8.4125 9.5875C8.1375 9.57917 7.9 9.475 7.7 9.275C7.51667 9.075 7.42083 8.84167 7.4125 8.575C7.40417 8.30833 7.5 8.075 7.7 7.875L11.3 4.275C11.4 4.175 11.5083 4.10417 11.625 4.0625C11.7417 4.02083 11.8667 4 12 4C12.1333 4 12.2583 4.02083 12.375 4.0625C12.4917 4.10417 12.6 4.175 12.7 4.275L16.3 7.875C16.5 8.075 16.5958 8.30833 16.5875 8.575C16.5792 8.84167 16.4833 9.075 16.3 9.275C16.1 9.475 15.8625 9.57917 15.5875 9.5875C15.3125 9.59583 15.075 9.5 14.875 9.3L13 7.425V14.575C13 14.8583 12.9042 15.0958 12.7125 15.2875C12.5208 15.4792 12.2833 15.575 12 15.575C11.7167 15.575 11.4792 15.4792 11.2875 15.2875C11.0958 15.0958 11 14.8583 11 14.575V7.425Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const HelpLine = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M10.5995 14.2377C10.6145 12.332 11.1547 11.7468 12.1001 11.1615C12.7453 10.7564 13.2255 10.2462 13.2255 9.4959C13.2255 8.65558 12.5803 8.11537 11.755 8.11537C11.0047 8.11537 10.2844 8.59555 10.2394 9.60094H8.36364C8.40865 7.59016 9.92424 6.55476 11.77 6.55476C13.7957 6.55476 15.1913 7.6802 15.1913 9.46589C15.1913 10.6814 14.576 11.4767 13.6007 12.0619C12.7303 12.5871 12.3702 13.1123 12.3552 14.2377V14.3728H10.5995V14.2377ZM11.5299 17.6891C10.8846 17.6891 10.3594 17.1639 10.3594 16.5186C10.3594 15.8884 10.8846 15.3632 11.5299 15.3632C12.1451 15.3632 12.6853 15.8884 12.6853 16.5186C12.6853 17.1639 12.1451 17.6891 11.5299 17.6891Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.81818C7.48131 3.81818 3.81818 7.48131 3.81818 12C3.81818 16.5187 7.48131 20.1818 12 20.1818C16.5187 20.1818 20.1818 16.5187 20.1818 12C20.1818 7.48131 16.5187 3.81818 12 3.81818ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const NotiOff = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12 21.1493C11.45 21.1493 10.9792 20.9534 10.5875 20.5618C10.1958 20.1701 10 19.6993 10 19.1493H14C14 19.6993 13.8042 20.1701 13.4125 20.5618C13.0208 20.9534 12.55 21.1493 12 21.1493Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        d="M5 18.1493C4.71667 18.1493 4.47917 18.0534 4.2875 17.8618C4.09583 17.6701 4 17.4326 4 17.1493C4 16.8659 4.09583 16.6284 4.2875 16.4368C4.47917 16.2451 4.71667 16.1493 5 16.1493H6V9.14925C6 7.76592 6.41667 6.53675 7.25 5.46175C8.08333 4.38675 9.4 3.54916 10.5 3.34925C11.6 3.14934 12.4 3.14907 13.5 3.34925C14.6 3.54944 15.9167 4.38675 16.75 5.46175C17.5833 6.53675 18 7.76592 18 9.14925V16.1493H19C19.2833 16.1493 19.5208 16.2451 19.7125 16.4368C19.9042 16.6284 20 16.8659 20 17.1493C20 17.4326 19.9042 17.6701 19.7125 17.8618C19.5208 18.0534 19.2833 18.1493 19 18.1493H5Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const WorstCase = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 23.2495L18 15.7495H13.8751L16.875 3.75L7.125 3.75L10.1249 15.7495H6L12 23.2495Z"
        fill="url(#paint0_linear_4034_29504)"
      />
      <path
        d="M19 14.251L22.5 9.87598H20.0925L21.624 3.75L16.374 3.75L17.9055 9.87598H15.5L19 14.251Z"
        fill="url(#paint1_linear_4034_29504)"
      />
      <path
        d="M5.99994 14.2511L10.4999 8.62614H7.406L9.37504 0.75L2.62514 0.750001L4.59417 8.62614H1.5L5.99994 14.2511Z"
        fill="url(#paint2_linear_4034_29504)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4034_29504"
          x1="12"
          y1="21.6246"
          x2="12"
          y2="3.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44619" stopColor="#0F62FE" />
          <stop offset="1" stopColor="#0F62FE" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4034_29504"
          x1="19"
          y1="13.3759"
          x2="19"
          y2="3.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44619" stopColor="#0F62FE" />
          <stop offset="1" stopColor="#0F62FE" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4034_29504"
          x1="6.00007"
          y1="13.1259"
          x2="6.00006"
          y2="0.749917"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44619" stopColor="#0F62FE" />
          <stop offset="1" stopColor="#0F62FE" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const Close = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <g clipPath="url(#clip0_4000_38258)">
        <path
          d="M9.98223 11.7494L5.56282 7.32995C5.31238 7.07952 5.18717 6.78489 5.18717 6.44607C5.18717 6.10725 5.31238 5.81262 5.56282 5.56218C5.81325 5.31175 6.10788 5.18653 6.4467 5.18653C6.78552 5.18653 7.08015 5.31175 7.33058 5.56218L11.75 9.9816L16.1694 5.56218C16.4199 5.31175 16.7145 5.18653 17.0533 5.18653C17.3921 5.18653 17.6868 5.31175 17.9372 5.56218C18.1876 5.81262 18.3128 6.10725 18.3128 6.44607C18.3128 6.78489 18.1876 7.07952 17.9372 7.32995L13.5178 11.7494L17.9372 16.1688C18.1876 16.4192 18.3128 16.7138 18.3128 17.0527C18.3128 17.3915 18.1876 17.6861 17.9372 17.9366C17.6868 18.187 17.3921 18.3122 17.0533 18.3122C16.7145 18.3122 16.4199 18.187 16.1694 17.9366L11.75 13.5171L7.33058 17.9366C7.08015 18.187 6.78552 18.3122 6.4467 18.3122C6.10788 18.3122 5.81325 18.187 5.56282 17.9366C5.31238 17.6861 5.18716 17.3915 5.18717 17.0527C5.18716 16.7138 5.31238 16.4192 5.56282 16.1688L9.98223 11.7494Z"
          fill={ICON_FILL[fill] ? "currentColor" : fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_4000_38258">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

/////////////////////////////////

const Search = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8492 16.2635C13.718 17.1032 12.317 17.6 10.8 17.6C7.04446 17.6 4 14.5555 4 10.8C4 7.04446 7.04446 4 10.8 4C14.5555 4 17.6 7.04446 17.6 10.8C17.6 12.3171 17.1032 13.7181 16.2634 14.8493L19.9154 18.5013C20.3059 18.8918 20.3059 19.525 19.9154 19.9155C19.5248 20.306 18.8917 20.306 18.5011 19.9155L14.8492 16.2635ZM15.6 10.8C15.6 13.451 13.451 15.6 10.8 15.6C8.14903 15.6 6 13.451 6 10.8C6 8.14903 8.14903 6 10.8 6C13.451 6 15.6 8.14903 15.6 10.8Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Menu = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M5.75402 18.4C5.48283 18.4 5.25551 18.3083 5.07205 18.1248C4.8886 17.9414 4.79688 17.714 4.79688 17.4429C4.79688 17.1717 4.8886 16.9443 5.07205 16.7609C5.25551 16.5774 5.48283 16.4857 5.75402 16.4857H18.7369C19.0081 16.4857 19.2354 16.5774 19.4188 16.7609C19.6023 16.9443 19.694 17.1717 19.694 17.4429C19.694 17.714 19.6023 17.9414 19.4188 18.1248C19.2354 18.3083 19.0081 18.4 18.7369 18.4H5.75402ZM5.75402 12.6571C5.48283 12.6571 5.25551 12.5654 5.07205 12.382C4.8886 12.1985 4.79688 11.9712 4.79688 11.7C4.79688 11.4288 4.8886 11.2015 5.07205 11.018C5.25551 10.8346 5.48283 10.7429 5.75402 10.7429H18.7369C19.0081 10.7429 19.2354 10.8346 19.4188 11.018C19.6023 11.2015 19.694 11.4288 19.694 11.7C19.694 11.9712 19.6023 12.1985 19.4188 12.382C19.2354 12.5654 19.0081 12.6571 18.7369 12.6571H5.75402ZM5.75402 6.91429C5.48283 6.91429 5.25551 6.82256 5.07205 6.63911C4.8886 6.45565 4.79688 6.22833 4.79688 5.95714C4.79688 5.68595 4.8886 5.45863 5.07205 5.27518C5.25551 5.09173 5.48283 5 5.75402 5H18.7369C19.0081 5 19.2354 5.09173 19.4188 5.27518C19.6023 5.45863 19.694 5.68595 19.694 5.95714C19.694 6.22833 19.6023 6.45565 19.4188 6.63911C19.2354 6.82256 19.0081 6.91429 18.7369 6.91429H5.75402Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Home = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M4.39844 18.1714L4.39844 10.3639C4.39844 10.0744 4.46573 9.8001 4.60031 9.54105C4.7349 9.282 4.92094 9.06867 5.15844 8.90105L10.8584 4.36571C11.1909 4.1219 11.5709 4 11.9984 4C12.4259 4 12.8059 4.1219 13.1384 4.36571L18.8384 8.90105C19.0759 9.06867 19.262 9.282 19.3966 9.54105C19.5311 9.8001 19.5984 10.0744 19.5984 10.3639V18.1714C19.5984 18.6743 19.4124 19.1048 19.0403 19.4629C18.6682 19.821 18.2209 20 17.6984 20H14.2616C13.9924 20 13.7668 19.9124 13.5847 19.7371C13.4026 19.5619 13.3116 19.3448 13.3116 19.0857V16.2827C13.3116 16.0237 13.2206 15.8065 13.0385 15.6313C12.8564 15.456 12.6308 15.3684 12.3616 15.3684H11.6516C11.3824 15.3684 11.1568 15.456 10.9747 15.6313C10.7926 15.8065 10.7016 16.0237 10.7016 16.2827V19.0857C10.7016 19.3448 10.6105 19.5619 10.4284 19.7371C10.2464 19.9124 10.0207 20 9.75156 20H6.29844C5.77594 20 5.32865 19.821 4.95656 19.4629C4.58448 19.1048 4.39844 18.6743 4.39844 18.1714Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const BestCase = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.742188L6 8.24219H10.125L7.125 20.2422H16.875L13.875 8.24219H18L12 0.742188Z"
        fill="url(#paint0_linear_5028_19595)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 9.74219L1.5 14.1172H3.90625L2.375 20.2422H7.625L6.09375 14.1172H8.5L5 9.74219Z"
        fill="url(#paint1_linear_5028_19595)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9999 9.74219L13.5 15.3671H16.5942L14.625 23.244H21.3749L19.4057 15.3671H22.4999L17.9999 9.74219Z"
        fill="url(#paint2_linear_5028_19595)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5028_19595"
          x1="11.9999"
          y1="2.36719"
          x2="11.9999"
          y2="20.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44619" stopColor="#FA4D56" />
          <stop offset="1" stopColor="#FA4D56" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5028_19595"
          x1="5"
          y1="10.6172"
          x2="5"
          y2="20.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44619" stopColor="#FA4D56" />
          <stop offset="1" stopColor="#FA4D56" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5028_19595"
          x1="17.9999"
          y1="10.8673"
          x2="17.9999"
          y2="23.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44619" stopColor="#FA4D56" />
          <stop offset="1" stopColor="#FA4D56" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const Grade = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M13.2487 4.7471L15.0033 8.47738L19.0962 8.98177C20.2457 9.12344 20.7117 10.5417 19.8709 11.3397L16.8714 14.2822L17.6053 18.4013C17.8107 19.5582 16.5892 20.4342 15.5745 19.8577L12.0002 17.8453L8.42589 19.8577C7.41121 20.4342 6.18969 19.5582 6.3951 18.4013L7.12897 14.2822L4.12952 11.3397C3.28872 10.5417 3.7547 9.12344 4.90421 8.98177L8.99706 8.47738L10.7674 4.74334C11.2634 3.69716 12.7559 3.69942 13.2487 4.7471Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width ? width : "20"}
    //   height={height ? height : "20"}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   className={ICON_FILL[fill] || ""}
    // >
    //   <path
    //     d="M13.4177 3.76085L15.41 7.99629L20.0571 8.56899C21.3623 8.72984 21.8914 10.3402 20.9367 11.2462L17.5311 14.5872L18.3643 19.2642C18.5975 20.5777 17.2106 21.5724 16.0585 20.9177L12.0002 18.6328L7.94183 20.9177C6.78974 21.5724 5.4028 20.5777 5.63603 19.2642L6.46928 14.5872L3.06364 11.2462C2.10898 10.3402 2.63805 8.72984 3.94323 8.56899L8.59035 7.99629L10.6004 3.75659C11.1636 2.56873 12.8582 2.5713 13.4177 3.76085Z"
    //     fill={ICON_FILL[fill] ? "currentColor" : fill}
    //   />
    // </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width ? width : "20"}
    //   height={height ? height : "20"}
    //   viewBox="0 0 36 36"
    //   fill="none"
    //   className={ICON_FILL[fill] || ""}
    // >
    //   <path
    //     d="M19.8715 7.11812L22.5035 12.7135L28.6428 13.4701C30.3671 13.6826 31.066 15.81 29.8048 17.007L25.3057 21.4207L26.4065 27.5995C26.7146 29.3348 24.8823 30.6488 23.3603 29.784L17.9988 26.7654L12.6374 29.784C11.1154 30.6488 9.28308 29.3348 9.59119 27.5995L10.692 21.4207L6.19282 17.007C4.93162 15.81 5.63058 13.6826 7.35485 13.4701L13.4941 12.7135L16.1496 7.11248C16.8936 5.54321 19.1323 5.5466 19.8715 7.11812Z"
    //     fill={ICON_FILL[fill] ? "currentColor" : fill}
    //   />
    // </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width ? width : "20"}
    //   height={height ? height : "20"}
    //   viewBox="0 0 20 20"
    //   fill="none"
    //   className={ICON_FILL[fill] || ""}
    // >
    //   <path
    //     d="M11.4177 1.76085L13.41 5.99629L18.0571 6.56899C19.3623 6.72984 19.8914 8.34019 18.9367 9.24622L15.5311 12.5872L16.3643 17.2642C16.5975 18.5777 15.2106 19.5724 14.0585 18.9177L10.0002 16.6328L5.94183 18.9177C4.78974 19.5724 3.4028 18.5777 3.63603 17.2642L4.46928 12.5872L1.06364 9.24622C0.108976 8.34019 0.638052 6.72984 1.94323 6.56899L6.59035 5.99629L8.60039 1.75659C9.16356 0.568729 10.8582 0.571296 11.4177 1.76085Z"
    //     fill={ICON_FILL[fill] ? "currentColor" : fill}
    //   />
    // </svg>
  );
};

const NotiOn = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8723 7.87023C17.5963 7.95398 17.3034 7.99902 17 7.99902C15.3431 7.99902 14 6.65588 14 4.99902C14 4.49666 14.1235 4.02314 14.3417 3.60715C14.055 3.48651 13.7709 3.39856 13.5 3.34925C12.4 3.14907 11.6 3.14934 10.5 3.34925C9.4 3.54916 8.08333 4.38675 7.25 5.46175C6.41667 6.53675 6 7.76592 6 9.14925V16.1493H5C4.71667 16.1493 4.47917 16.2451 4.2875 16.4368C4.09583 16.6284 4 16.8659 4 17.1493C4 17.4326 4.09583 17.6701 4.2875 17.8618C4.47917 18.0534 4.71667 18.1493 5 18.1493H19C19.2833 18.1493 19.5208 18.0534 19.7125 17.8618C19.9042 17.6701 20 17.4326 20 17.1493C20 16.8659 19.9042 16.6284 19.7125 16.4368C19.5208 16.2451 19.2833 16.1493 19 16.1493H18V9.14925C18 8.70717 17.9574 8.28082 17.8723 7.87023ZM10.5875 20.5618C10.9792 20.9534 11.45 21.1493 12 21.1493C12.55 21.1493 13.0208 20.9534 13.4125 20.5618C13.8042 20.1701 14 19.6993 14 19.1493H10C10 19.6993 10.1958 20.1701 10.5875 20.5618Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 5C19 6.10457 18.1046 7 17 7C15.8954 7 15 6.10457 15 5C15 3.89543 15.8954 3 17 3C18.1046 3 19 3.89543 19 5Z"
        fill="#FF0000"
      />
    </svg>
  );
};

const PieChart = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12.8112 11.201V4C14.7395 4.20228 16.3678 4.97092 17.6961 6.30594C19.0243 7.64096 19.7963 9.27265 20.0121 11.201H12.8112ZM11.2133 20C9.16359 19.7977 7.44765 18.9347 6.06547 17.4109C4.68328 15.8871 3.99219 14.0868 3.99219 12.0101C3.99219 9.91993 4.68328 8.11294 6.06547 6.58913C7.44765 5.06532 9.16359 4.20228 11.2133 4V20ZM12.8112 20V12.799H20.0121C19.8233 14.7274 19.058 16.3624 17.7163 17.7042C16.3746 19.0459 14.7395 19.8112 12.8112 20Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const ArrowForward = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M16.175 12.9982H5C4.71667 12.9982 4.47917 12.9023 4.2875 12.7107C4.09583 12.519 4 12.2815 4 11.9982C4 11.7148 4.09583 11.4773 4.2875 11.2857C4.47917 11.094 4.71667 10.9982 5 10.9982H16.175L11.275 6.09816C11.075 5.89816 10.9792 5.66482 10.9875 5.39816C10.9958 5.13149 11.1 4.89816 11.3 4.69816C11.5 4.51482 11.7333 4.41899 12 4.41066C12.2667 4.40232 12.5 4.49816 12.7 4.69816L19.3 11.2982C19.4 11.3982 19.4708 11.5065 19.5125 11.6232C19.5542 11.7398 19.575 11.8648 19.575 11.9982C19.575 12.1315 19.5542 12.2565 19.5125 12.3732C19.4708 12.4898 19.4 12.5982 19.3 12.6982L12.7 19.2982C12.5167 19.4815 12.2875 19.5732 12.0125 19.5732C11.7375 19.5732 11.5 19.4815 11.3 19.2982C11.1 19.0982 11 18.8607 11 18.5857C11 18.3107 11.1 18.0732 11.3 17.8732L16.175 12.9982Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};
const Line = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.7561 11.8796H3V19.2016H21V11.8796H18.3659L15.2143 3.60156L10.7143 15.2884L6.32404 7.49695L4.7561 11.8796Z"
        fill="var(--red10)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2138 2.91406C15.4979 2.9146 15.7523 3.09028 15.8533 3.3558L18.8367 11.1921H20.9982C21.3769 11.1921 21.6839 11.4992 21.6839 11.8779C21.6839 12.2566 21.3769 12.5636 20.9982 12.5636H18.3641C18.0795 12.5636 17.8245 12.3878 17.7232 12.1218L15.2089 5.5175L11.3524 15.533C11.2562 15.7828 11.0235 15.9538 10.7564 15.9709C10.4893 15.9881 10.2366 15.8482 10.1093 15.6128L6.54755 9.02578L5.39695 12.1171C5.29703 12.3855 5.04076 12.5636 4.75431 12.5636H2.99821C2.6195 12.5636 2.3125 12.2566 2.3125 11.8779C2.3125 11.4992 2.6195 11.1921 2.99821 11.1921H4.27787L5.78937 7.13125C5.88322 6.8791 6.11587 6.70513 6.38426 6.6864C6.65266 6.66767 6.90722 6.80763 7.03519 7.04429L10.6075 13.6509L14.5726 3.35338C14.6747 3.08825 14.9297 2.91353 15.2138 2.91406Z"
        fill="var(--red40)"
      />
    </svg>
  );
};

const Back = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M8.725 12.0065L16.075 19.3708C16.325 19.6213 16.4458 19.9136 16.4375 20.2476C16.4292 20.5815 16.3 20.8738 16.05 21.1243C15.8 21.3748 15.5083 21.5 15.175 21.5C14.8417 21.5 14.55 21.3748 14.3 21.1243L6.6 13.4343C6.4 13.2339 6.25 13.0084 6.15 12.7579C6.05 12.5074 6 12.257 6 12.0065C6 11.756 6.05 11.5055 6.15 11.255C6.25 11.0045 6.4 10.7791 6.6 10.5787L14.3 2.86361C14.55 2.61312 14.8458 2.49205 15.1875 2.5004C15.5292 2.50875 15.825 2.63817 16.075 2.88866C16.325 3.13915 16.45 3.43139 16.45 3.76537C16.45 4.09936 16.325 4.3916 16.075 4.64209L8.725 12.0065Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Forward = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M15.275 11.9935L7.925 4.62916C7.675 4.37867 7.55417 4.08643 7.5625 3.75245C7.57084 3.41846 7.7 3.12622 7.95 2.87573C8.2 2.62524 8.49167 2.5 8.825 2.5C9.15833 2.5 9.45 2.62524 9.7 2.87573L17.4 10.5657C17.6 10.7661 17.75 10.9916 17.85 11.2421C17.95 11.4926 18 11.743 18 11.9935C18 12.244 17.95 12.4945 17.85 12.745C17.75 12.9955 17.6 13.2209 17.4 13.4213L9.7 21.1364C9.45 21.3869 9.15417 21.5079 8.8125 21.4996C8.47084 21.4912 8.175 21.3618 7.925 21.1113C7.675 20.8608 7.55 20.5686 7.55 20.2346C7.55 19.9006 7.675 19.6084 7.925 19.3579L15.275 11.9935Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Expand = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12.0582 15.275L19.4082 7.925C19.6582 7.675 19.9499 7.55417 20.2832 7.5625C20.6165 7.57083 20.9082 7.7 21.1582 7.95C21.4082 8.2 21.5332 8.49167 21.5332 8.825C21.5332 9.15833 21.4082 9.45 21.1582 9.7L13.4832 17.4C13.2832 17.6 13.0582 17.75 12.8082 17.85C12.5582 17.95 12.3082 18 12.0582 18C11.8082 18 11.5582 17.95 11.3082 17.85C11.0582 17.75 10.8332 17.6 10.6332 17.4L2.93322 9.7C2.68322 9.45 2.56238 9.15417 2.57072 8.8125C2.57905 8.47083 2.70822 8.175 2.95822 7.925C3.20822 7.675 3.49988 7.55 3.83322 7.55C4.16655 7.55 4.45822 7.675 4.70822 7.925L12.0582 15.275Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Collapse = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12.0433 8.725L4.69335 16.075C4.44335 16.325 4.15168 16.4458 3.81835 16.4375C3.48501 16.4292 3.19335 16.3 2.94335 16.05C2.69335 15.8 2.56835 15.5083 2.56835 15.175C2.56835 14.8417 2.69335 14.55 2.94335 14.3L10.6183 6.6C10.8183 6.4 11.0433 6.25 11.2933 6.15C11.5433 6.05 11.7933 6 12.0433 6C12.2933 6 12.5433 6.05 12.7933 6.15C13.0433 6.25 13.2683 6.4 13.4683 6.6L21.1683 14.3C21.4183 14.55 21.5392 14.8458 21.5308 15.1875C21.5225 15.5292 21.3933 15.825 21.1433 16.075C20.8933 16.325 20.6017 16.45 20.2683 16.45C19.935 16.45 19.6433 16.325 19.3933 16.075L12.0433 8.725Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Candle = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.20078V4.80078H7.2V7.20078H6ZM4.20312 7.20117H9.00313V13.2012H7.2L7.2 18.0002H6L6 13.2012H4.20312V7.20117Z"
        fill="#FA4D56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8 3.60156H15V10.8016H19.8V3.60156ZM16.7969 10.8018V14.4018H17.9969V10.8018H16.7969Z"
        fill="#FA4D56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3984 4.80156V3.60156H12.5984V4.80156H14.4016V18.0016H9.60156V4.80156H11.3984ZM11.3984 20.402V18.002H12.5984V20.402H11.3984Z"
        fill="#0F62FE"
      />
    </svg>
  );
};

const Up = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M6 15L12 9L18 15H6Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Down = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M6 9L12 15L18 9H6Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const ExpandAll = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12.0021 19.1516L15.8771 15.2766C16.0771 15.0766 16.3104 14.9766 16.5771 14.9766C16.8437 14.9766 17.0771 15.0766 17.2771 15.2766C17.4771 15.4766 17.5771 15.7141 17.5771 15.9891C17.5771 16.2641 17.4771 16.5016 17.2771 16.7016L13.4271 20.5766C13.0437 20.9599 12.5687 21.1516 12.0021 21.1516C11.4354 21.1516 10.9604 20.9599 10.5771 20.5766L6.70206 16.7016C6.50206 16.5016 6.40623 16.2641 6.41456 15.9891C6.4229 15.7141 6.52706 15.4766 6.72706 15.2766C6.92706 15.0766 7.16456 14.9766 7.43956 14.9766C7.71456 14.9766 7.95206 15.0766 8.15206 15.2766L12.0021 19.1516ZM12.0021 4.85156L8.15206 8.70156C7.95206 8.90156 7.71873 8.9974 7.45206 8.98906C7.1854 8.98073 6.95206 8.8849 6.75206 8.70156C6.55206 8.50156 6.4479 8.26406 6.43956 7.98906C6.43123 7.71406 6.52706 7.47656 6.72706 7.27656L10.5771 3.42656C10.9604 3.04323 11.4354 2.85156 12.0021 2.85156C12.5687 2.85156 13.0437 3.04323 13.4271 3.42656L17.2771 7.27656C17.4771 7.47656 17.5729 7.71406 17.5646 7.98906C17.5562 8.26406 17.4521 8.50156 17.2521 8.70156C17.0521 8.8849 16.8187 8.98073 16.5521 8.98906C16.2854 8.9974 16.0521 8.90156 15.8521 8.70156L12.0021 4.85156Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Check = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M9.55363 15.15L18.0286 6.675C18.2286 6.475 18.4661 6.375 18.7411 6.375C19.0161 6.375 19.2536 6.475 19.4536 6.675C19.6536 6.875 19.7536 7.1125 19.7536 7.3875C19.7536 7.6625 19.6536 7.9 19.4536 8.1L10.2536 17.3C10.0536 17.5 9.82029 17.6 9.55363 17.6C9.28696 17.6 9.05363 17.5 8.85363 17.3L4.55363 13C4.35363 12.8 4.25779 12.5625 4.26612 12.2875C4.27446 12.0125 4.37863 11.775 4.57863 11.575C4.77863 11.375 5.01613 11.275 5.29113 11.275C5.56613 11.275 5.80362 11.375 6.00362 11.575L9.55363 15.15Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Cancel = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12 13.4L14.9 16.3C15.0833 16.4833 15.3167 16.575 15.6 16.575C15.8833 16.575 16.1167 16.4833 16.3 16.3C16.4833 16.1167 16.575 15.8833 16.575 15.6C16.575 15.3167 16.4833 15.0833 16.3 14.9L13.4 12L16.3 9.1C16.4833 8.91667 16.575 8.68333 16.575 8.4C16.575 8.11667 16.4833 7.88333 16.3 7.7C16.1167 7.51667 15.8833 7.425 15.6 7.425C15.3167 7.425 15.0833 7.51667 14.9 7.7L12 10.6L9.1 7.7C8.91667 7.51667 8.68333 7.425 8.4 7.425C8.11667 7.425 7.88333 7.51667 7.7 7.7C7.51667 7.88333 7.425 8.11667 7.425 8.4C7.425 8.68333 7.51667 8.91667 7.7 9.1L10.6 12L7.7 14.9C7.51667 15.0833 7.425 15.3167 7.425 15.6C7.425 15.8833 7.51667 16.1167 7.7 16.3C7.88333 16.4833 8.11667 16.575 8.4 16.575C8.68333 16.575 8.91667 16.4833 9.1 16.3L12 13.4ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const TextValue = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return <p>주</p>;
};

const RadioButtonChecked = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12 17C13.3833 17 14.5625 16.5125 15.5375 15.5375C16.5125 14.5625 17 13.3833 17 12C17 10.6167 16.5125 9.4375 15.5375 8.4625C14.5625 7.4875 13.3833 7 12 7C10.6167 7 9.4375 7.4875 8.4625 8.4625C7.4875 9.4375 7 10.6167 7 12C7 13.3833 7.4875 14.5625 8.4625 15.5375C9.4375 16.5125 10.6167 17 12 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Ai = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M20.7572 15.3618C21.0418 15.2452 21.3227 15.1206 21.6008 14.9894C21.6272 14.985 21.6517 14.9759 21.6714 14.9572C21.6989 14.9554 21.7218 14.9426 21.7433 14.9268C21.7604 14.9182 21.7776 14.9095 21.7947 14.9009C21.8283 14.9002 21.8549 14.8823 21.8821 14.8656L22.0399 14.7957C22.11 14.7722 22.1769 14.7426 22.235 14.6959C22.2973 14.6663 22.3497 14.6244 22.3921 14.5702C22.4629 14.5085 22.5173 14.4352 22.5525 14.3479C22.7616 13.9944 22.6941 13.3561 22.1809 13.0869C22.0909 13.0366 21.9969 12.9947 21.8995 12.9607C21.8088 12.9125 21.7153 12.8702 21.6181 12.8367C21.5043 12.7766 21.3866 12.7254 21.2662 12.6807C21.1105 12.605 20.9532 12.5325 20.7914 12.4707C20.6922 12.4266 20.593 12.3825 20.4939 12.3385C20.1852 12.2001 19.8764 12.0616 19.5675 11.9233C19.4365 11.8524 19.3053 11.7816 19.1742 11.711C19.08 11.6542 18.9858 11.5973 18.8917 11.5404C18.8437 11.4979 18.7885 11.466 18.7325 11.4355C18.7227 11.4289 18.7128 11.4222 18.7028 11.4157C18.6864 11.3834 18.6466 11.3875 18.6237 11.3656C18.6114 11.3352 18.5823 11.3263 18.5566 11.313C18.5254 11.2898 18.5045 11.2488 18.4557 11.2574C18.4231 11.2043 18.3585 11.1864 18.3216 11.138C18.2947 11.1084 18.2655 11.0815 18.2287 11.0643C18.194 11.0354 18.1593 11.0067 18.1244 10.9777C18.0953 10.957 18.0615 10.9421 18.0416 10.9102C18.0307 10.882 18.0059 10.8692 17.9816 10.8555C17.9441 10.8213 17.9065 10.7871 17.8692 10.753C17.8363 10.7226 17.8035 10.6925 17.7706 10.6621C17.7607 10.6341 17.7294 10.6313 17.7119 10.6123C17.7005 10.579 17.6727 10.5606 17.6466 10.5406C17.5962 10.4851 17.5503 10.4247 17.4854 10.3837C17.4546 10.349 17.424 10.3143 17.3932 10.2796C17.3923 10.2605 17.3784 10.2515 17.3641 10.2428C17.3512 10.22 17.3361 10.1998 17.3097 10.1912C17.2963 10.1742 17.2829 10.1572 17.2695 10.14C17.2692 10.1211 17.2556 10.1118 17.2417 10.1028C17.2107 10.0683 17.1797 10.0338 17.1487 9.99922C17.1455 9.96819 17.1168 9.96065 17.0978 9.94399C17.0881 9.92664 17.0783 9.90928 17.0686 9.89175C17.0568 9.86352 17.0379 9.84072 17.0138 9.82196C17.0057 9.78988 16.9773 9.7748 16.9559 9.75376C16.9469 9.70888 16.9122 9.68135 16.8845 9.64909C16.8701 9.61297 16.8435 9.5865 16.8151 9.56108C16.8157 9.52969 16.7908 9.51286 16.7746 9.49112C16.7575 9.46798 16.7405 9.44483 16.7234 9.42169C16.7149 9.38627 16.6908 9.36067 16.669 9.3335C16.6408 9.29265 16.6126 9.2518 16.5844 9.21077C16.5689 9.15642 16.537 9.11153 16.5016 9.06875C16.4833 9.04 16.465 9.01142 16.4467 8.98267C16.4409 8.94146 16.4182 8.90903 16.3926 8.87799C16.3653 8.8154 16.3384 8.75246 16.2908 8.70144C16.2833 8.68443 16.2755 8.66742 16.2679 8.65042C16.2628 8.60974 16.2426 8.57625 16.2181 8.54469C16.1998 8.51577 16.1815 8.48684 16.1631 8.45791C16.1684 8.42267 16.1443 8.39829 16.1306 8.37007C16.1277 8.32273 16.1038 8.28416 16.079 8.24611C16.0716 8.2149 16.0628 8.18422 16.0414 8.1588C16.0356 8.12759 16.0263 8.09778 16.0053 8.07271C15.9888 8.01625 15.9701 7.96085 15.9372 7.91123C15.934 7.8788 15.9227 7.84969 15.9013 7.82479C15.8956 7.79341 15.8863 7.76343 15.8653 7.73836C15.8653 7.72363 15.8625 7.71013 15.8497 7.70084C15.8482 7.68243 15.8463 7.66437 15.8298 7.6521C15.8276 7.62422 15.8157 7.6002 15.7991 7.57828C15.7914 7.56215 15.7836 7.54585 15.7759 7.52954C15.7597 7.48851 15.7435 7.44731 15.7271 7.40629C15.71 7.34492 15.6873 7.28583 15.6542 7.23113C15.641 7.17468 15.6186 7.1219 15.5886 7.07211C15.5805 7.05528 15.5724 7.03845 15.5643 7.02161C15.5524 6.9983 15.5402 6.97498 15.5282 6.95148C15.5362 6.91484 15.5184 6.88644 15.4985 6.85856C15.486 6.83103 15.4735 6.80368 15.461 6.77615C15.4368 6.73776 15.4465 6.68656 15.4138 6.65132C15.4007 6.6024 15.3822 6.55594 15.3551 6.51281C15.3331 6.4397 15.3051 6.36887 15.2674 6.30224C15.254 6.24613 15.2317 6.19354 15.2022 6.14409C15.182 6.07536 15.1547 6.00997 15.1115 5.95193C15.0777 5.87847 15.0305 5.81535 14.9664 5.76538C14.9009 5.69701 14.8329 5.63161 14.7399 5.60093C14.664 5.55394 14.5812 5.52764 14.4927 5.51782C14.4802 5.51256 14.4631 5.51501 14.4576 5.49766H14.2112C14.1984 5.5201 14.1751 5.51186 14.1563 5.51607C13.8312 5.59111 13.602 5.77678 13.4847 6.09185C13.4451 6.17092 13.4044 6.24947 13.3835 6.33625C13.3164 6.47319 13.2579 6.6138 13.2079 6.75774C13.142 6.8952 13.079 7.03371 13.0323 7.17888C12.9717 7.30354 12.9159 7.42995 12.8727 7.5618C12.807 7.69961 12.7415 7.83759 12.6966 7.98399C12.6142 8.16932 12.5316 8.35464 12.4492 8.53996C12.3563 8.71108 12.2635 8.88238 12.1707 9.0535C11.9617 9.39416 11.7308 9.71975 11.4814 10.0324C11.4139 10.0881 11.3671 10.1616 11.3121 10.228L10.9252 10.6309C10.8174 10.7291 10.7098 10.8275 10.602 10.9257C10.5483 10.959 10.4992 10.9977 10.4583 11.0463C10.4233 11.0605 10.3976 11.0864 10.3734 11.1141C10.2787 11.1706 10.1945 11.2409 10.1103 11.3114C10.0272 11.3691 9.94388 11.4267 9.86075 11.4844C9.80967 11.5049 9.76582 11.5365 9.7239 11.5714L9.49407 11.709C9.43542 11.7306 9.38347 11.7641 9.33292 11.8C9.25877 11.8258 9.1922 11.8659 9.12651 11.9079C9.05148 11.9347 8.98068 11.9703 8.91253 12.0111C8.83257 12.0392 8.75508 12.0723 8.68164 12.1147C8.62334 12.1365 8.56381 12.1556 8.51098 12.1896C8.45462 12.205 8.40284 12.2305 8.35265 12.2597C8.29629 12.2752 8.24416 12.3004 8.19396 12.3297C8.12369 12.36 8.05342 12.3904 7.98315 12.4207C7.91869 12.4494 7.85405 12.4782 7.7896 12.5069C7.72883 12.5301 7.66719 12.5513 7.61242 12.5874C7.54426 12.6078 7.48016 12.6369 7.41851 12.6719C7.33398 12.7038 7.24944 12.7352 7.17177 12.7824C7.12774 12.7922 7.08759 12.8103 7.0506 12.8359C6.98051 12.8527 6.91834 12.8872 6.85617 12.9216C6.80016 12.939 6.74539 12.9591 6.69643 12.9923C6.6406 13.007 6.58812 13.0296 6.53986 13.0615C6.44493 13.0947 6.36638 13.1529 6.29488 13.2216C5.94299 13.52 5.90125 14.1436 6.20946 14.4997C6.26829 14.5835 6.34349 14.6488 6.43331 14.6979C6.48174 14.7345 6.53334 14.7648 6.59322 14.7792C6.63144 14.8032 6.67142 14.8236 6.71615 14.8329C6.76564 14.8635 6.81813 14.8876 6.87448 14.9028C6.92538 14.9307 6.97452 14.9619 7.03281 14.9729C7.09833 15.0101 7.16596 15.0427 7.2387 15.0634C7.28783 15.0953 7.34085 15.1185 7.3972 15.1337C7.45937 15.1712 7.52542 15.2 7.59463 15.2214C7.64324 15.2522 7.6952 15.2754 7.7512 15.2899C7.81179 15.3297 7.8803 15.3525 7.94669 15.3795C7.99425 15.4141 8.05201 15.4258 8.10467 15.4491C8.15205 15.47 8.1996 15.4909 8.24697 15.5117C8.30192 15.5449 8.36004 15.5708 8.42256 15.5868C8.47188 15.6168 8.52383 15.641 8.57966 15.6564C8.65839 15.7007 8.74081 15.7365 8.82623 15.7658C8.87061 15.7944 8.91799 15.8165 8.96906 15.8305C9.00569 15.8557 9.04444 15.8759 9.08829 15.8855C9.15927 15.9217 9.23007 15.9579 9.30104 15.9941C9.33098 16.0097 9.3611 16.0253 9.39104 16.0411C9.46378 16.0884 9.53651 16.1357 9.6177 16.1682C9.6723 16.2095 9.72989 16.2464 9.79241 16.2751C9.80562 16.2919 9.82042 16.3063 9.84384 16.3067C9.87554 16.3372 9.91147 16.361 9.95233 16.3772C9.99865 16.4194 10.0506 16.4534 10.1066 16.4815C10.1638 16.5385 10.2304 16.5828 10.3007 16.6221C10.3195 16.6458 10.341 16.6657 10.3708 16.675C10.4194 16.7148 10.468 16.7546 10.5168 16.7943C10.5689 16.8367 10.6209 16.8789 10.673 16.9214C10.7 16.9533 10.729 16.9826 10.766 17.0031C10.8056 17.0388 10.8454 17.0746 10.8851 17.1104C10.9111 17.143 10.9368 17.1761 10.9742 17.1972C11.0731 17.2968 11.1723 17.3965 11.2713 17.4961C11.3828 17.6244 11.4942 17.753 11.6057 17.8813C11.7359 18.0559 11.8662 18.2306 11.9964 18.4052C12.1557 18.6531 12.3044 18.9075 12.4488 19.1642C12.5358 19.3497 12.6228 19.5354 12.7098 19.7208C12.7824 19.9179 12.8733 20.1069 12.9627 20.2966C13.0534 20.5239 13.1503 20.7485 13.2577 20.9685C13.3146 21.1223 13.381 21.272 13.4548 21.4186C13.4594 21.4724 13.4904 21.5166 13.5138 21.5618C13.6672 21.8576 13.9011 22.0412 14.2436 22.0678C14.3923 22.1002 14.5318 22.0639 14.669 22.0108C14.7709 21.9758 14.8613 21.9226 14.9354 21.8437C14.9826 21.8069 15.0252 21.7659 15.055 21.7133C15.0918 21.6747 15.124 21.6335 15.1306 21.5781C15.1415 21.5604 15.1524 21.5429 15.1631 21.5252C15.185 21.4996 15.1987 21.4706 15.1985 21.4363C15.2044 21.4256 15.2103 21.4149 15.2162 21.4042C15.235 21.383 15.2463 21.3584 15.2493 21.3304C15.2709 21.3128 15.2692 21.2872 15.2725 21.2634C15.2899 21.2282 15.3076 21.1929 15.325 21.1577C15.3486 21.121 15.369 21.083 15.3757 21.0391C15.4051 21.0079 15.4074 20.9645 15.4256 20.9282C15.4474 20.9033 15.4564 20.8728 15.4625 20.8412C15.4902 20.811 15.499 20.7725 15.5113 20.7353C15.5245 20.7006 15.5377 20.6659 15.5511 20.6313C15.5737 20.6134 15.582 20.5886 15.5862 20.5614C15.6145 20.5249 15.6276 20.4818 15.6402 20.4386C15.6491 20.4208 15.658 20.4029 15.6668 20.385C15.6917 20.3266 15.7163 20.2682 15.7412 20.2098C15.7641 20.1711 15.7859 20.132 15.7945 20.0873C15.8151 20.0615 15.8282 20.0329 15.8294 19.9996C15.8622 19.9575 15.8796 19.9083 15.8969 19.8588C15.9106 19.8199 15.9245 19.781 15.9382 19.7421C15.9539 19.7331 15.9636 19.7198 15.9662 19.7017C15.9747 19.6746 15.9831 19.6472 15.9914 19.62C16.0092 19.5901 16.0386 19.566 16.039 19.5273C16.0478 19.5047 16.0568 19.4819 16.0656 19.4593C16.0983 19.4314 16.111 19.394 16.1159 19.353C16.1392 19.3209 16.1598 19.2876 16.1675 19.248C16.1825 19.2241 16.1977 19.2003 16.2126 19.1763C16.2213 19.1535 16.2297 19.1307 16.2383 19.1081C16.254 19.0842 16.2697 19.0602 16.2854 19.0364C16.3009 19.0152 16.3202 18.9959 16.3201 18.9669C16.3361 18.9391 16.3585 18.9145 16.3625 18.8808C16.3766 18.8626 16.3907 18.8444 16.405 18.8261C16.4116 18.8144 16.4183 18.8028 16.425 18.7911C16.4384 18.7679 16.4518 18.7448 16.4652 18.7217C16.4719 18.7104 16.4786 18.6994 16.4851 18.6882C16.5154 18.6575 16.5355 18.6205 16.5522 18.5814C16.5913 18.5228 16.6302 18.4643 16.6693 18.4057C16.6845 18.3829 16.6996 18.3601 16.7147 18.3373C16.7371 18.318 16.7553 18.2958 16.7605 18.2656C16.7789 18.2423 16.7972 18.219 16.8155 18.1957C16.8456 18.155 16.8757 18.1145 16.9058 18.0738C16.9256 18.0619 16.937 18.0435 16.9453 18.0228C16.9636 18.0079 16.9807 17.9919 16.9865 17.9679C17.0156 17.9328 17.0446 17.8978 17.0735 17.8627C17.0888 17.8469 17.1091 17.8347 17.1115 17.8098C17.1476 17.7691 17.1839 17.7284 17.22 17.6879C17.2417 17.6756 17.2568 17.6574 17.2674 17.6353C17.2704 17.6255 17.2734 17.6159 17.2762 17.606C17.2991 17.5869 17.3331 17.5808 17.3445 17.5484C17.3542 17.5457 17.3599 17.5405 17.3574 17.5296C17.3826 17.501 17.4076 17.4723 17.4328 17.4437C17.4893 17.4081 17.5328 17.3593 17.5742 17.3082C17.6107 17.2724 17.6473 17.2366 17.6837 17.2007C17.7292 17.1716 17.7665 17.1339 17.8002 17.0923C17.8243 17.0809 17.8426 17.0634 17.8565 17.041C17.868 17.0306 17.8794 17.0201 17.8909 17.0097C18.1129 16.8323 18.335 16.6551 18.5571 16.4776C18.5957 16.4769 18.6188 16.4471 18.6466 16.4282C19.0189 16.175 19.4123 15.9604 19.8243 15.7782C20.1358 15.6404 20.4463 15.501 20.7572 15.3618Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        d="M9.67815 5.77614C9.67445 5.75668 9.67744 5.73512 9.66106 5.71951C9.64468 5.65639 9.62549 5.5945 9.57512 5.54822C9.53708 5.48369 9.47878 5.44372 9.41168 5.41444C9.37399 5.37762 9.31675 5.38516 9.27589 5.35535C9.2139 5.31731 9.14715 5.29013 9.07829 5.26751C9.04271 5.24121 9.0022 5.22614 8.95976 5.21579C8.9145 5.17231 8.84194 5.18932 8.79791 5.14338C8.7655 5.11971 8.72904 5.10463 8.6903 5.09534C8.63077 5.058 8.56666 5.03012 8.50097 5.00557C8.43581 4.96981 8.37082 4.93386 8.30566 4.8981C8.25352 4.85567 8.19364 4.82569 8.13429 4.795C8.07494 4.75415 8.01541 4.7133 7.95606 4.67245C7.89636 4.62651 7.83648 4.5804 7.77677 4.53446C7.71566 4.48222 7.65455 4.42979 7.59343 4.37755C7.54958 4.33617 7.50572 4.29479 7.46205 4.25341C7.43721 4.23062 7.41238 4.20765 7.38755 4.18486C7.37469 4.14646 7.3407 4.12542 7.31464 4.09807C7.27325 4.05143 7.23186 4.0048 7.19047 3.95816C7.16247 3.92274 7.13464 3.8875 7.10664 3.85208C7.07758 3.81702 7.04835 3.78178 7.01929 3.74671C7.01312 3.69972 6.97649 3.67342 6.94761 3.64169C6.94074 3.60592 6.91502 3.58155 6.89442 3.55403C6.87645 3.5251 6.85831 3.49617 6.84035 3.46724C6.82274 3.43778 6.80513 3.40833 6.78734 3.37887C6.76779 3.32698 6.73873 3.28069 6.70245 3.23879C6.70245 3.20425 6.68149 3.17865 6.66458 3.1513C6.64909 3.12149 6.63359 3.09186 6.61809 3.06205C6.59026 2.97667 6.55187 2.89567 6.50995 2.81642C6.47948 2.73173 6.45377 2.64512 6.40604 2.56745C6.39724 2.51853 6.37593 2.47488 6.35074 2.43262C6.33965 2.40913 6.32855 2.38581 6.31746 2.36232C6.30002 2.2736 6.25916 2.19751 6.19206 2.13597C6.14222 2.07215 6.07635 2.03358 5.99833 2.01446C5.73486 1.96116 5.5443 2.02306 5.43598 2.21048C5.36078 2.34058 5.30548 2.48119 5.25934 2.62478C5.19946 2.74471 5.14609 2.86744 5.10171 2.99385C5.03655 3.12114 4.97121 3.24843 4.90604 3.37572C4.86642 3.43112 4.82609 3.486 4.79949 3.54947C4.74683 3.62556 4.69417 3.70148 4.64151 3.77757C4.51929 3.91924 4.39706 4.06108 4.27483 4.20274C4.12232 4.34932 3.96698 4.49256 3.79879 4.62125C3.71636 4.67981 3.63394 4.73837 3.55152 4.79711C3.47068 4.83691 3.39283 4.88162 3.32133 4.93667C3.1512 5.0182 2.98107 5.09972 2.81094 5.18125C2.69047 5.22526 2.57265 5.27523 2.45958 5.33589C2.3791 5.36167 2.3016 5.3941 2.23186 5.44267C2.17462 5.4595 2.14486 5.50771 2.10981 5.54979C2.06684 5.60134 2.03549 5.6585 2.02439 5.72547C2.0059 5.77071 1.99991 5.8177 2.00661 5.86609C1.99991 5.92324 2.00414 5.97847 2.03672 6.02844C2.04747 6.10488 2.09026 6.16239 2.14662 6.21183C2.18484 6.25462 2.22675 6.29196 2.28382 6.30827C2.33929 6.34386 2.39988 6.36823 2.46222 6.38909C2.57565 6.45063 2.69453 6.4999 2.81499 6.54584C2.94391 6.6044 3.07283 6.66296 3.20175 6.72169C3.312 6.78306 3.42207 6.84442 3.53232 6.90596C3.60911 6.95716 3.6859 7.00835 3.76268 7.05955C3.83894 7.11828 3.91538 7.17685 3.99164 7.23558C4.05064 7.2873 4.10946 7.33902 4.16828 7.39075C4.22094 7.44334 4.27378 7.49594 4.32644 7.54872C4.3481 7.58554 4.38068 7.61183 4.41344 7.63813C4.44409 7.68284 4.47209 7.72983 4.51911 7.76069C4.55363 7.80277 4.58815 7.84467 4.62267 7.88675C4.65102 7.94251 4.69347 7.98792 4.73274 8.0356C4.76163 8.07733 4.79033 8.11924 4.81922 8.16096C4.8525 8.21426 4.88561 8.26739 4.9189 8.32069C4.94902 8.37311 4.97896 8.42554 5.00907 8.47813C5.02668 8.52775 5.04976 8.57474 5.08181 8.61699C5.09784 8.6731 5.12425 8.72465 5.15472 8.77409C5.17674 8.84177 5.20368 8.90751 5.24102 8.96835C5.2574 9.02411 5.27801 9.07828 5.31041 9.12703C5.32644 9.18313 5.34757 9.23696 5.38015 9.28605C5.39266 9.33742 5.41379 9.38423 5.45095 9.42298C5.49093 9.49644 5.55187 9.54571 5.62883 9.57674C5.87293 9.70386 6.17198 9.60006 6.27941 9.35109C6.32679 9.27535 6.35462 9.19102 6.38614 9.10844C6.43035 9.03007 6.46592 8.94819 6.4941 8.8628C6.53408 8.80424 6.55328 8.73639 6.58058 8.67222C6.6269 8.58333 6.67304 8.49462 6.71936 8.40572C6.7847 8.30105 6.85004 8.19638 6.91538 8.09171C6.99058 7.99212 7.06596 7.89253 7.14116 7.79295C7.2729 7.65374 7.40481 7.51453 7.53655 7.37532C7.64539 7.28748 7.75264 7.19771 7.86342 7.11232C8.09784 6.93173 8.35691 6.79095 8.62073 6.65857C8.88579 6.54233 9.15278 6.43012 9.4152 6.30809C9.56878 6.23673 9.65402 6.10664 9.67868 5.93902L9.68607 5.93955L9.69294 5.93657V5.77895C9.68801 5.77737 9.68325 5.77597 9.67815 5.77614Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Help = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M20.7572 15.3618C21.0418 15.2452 21.3227 15.1206 21.6008 14.9894C21.6272 14.985 21.6517 14.9759 21.6714 14.9572C21.6989 14.9554 21.7218 14.9426 21.7433 14.9268C21.7604 14.9182 21.7776 14.9095 21.7947 14.9009C21.8283 14.9002 21.8549 14.8823 21.8821 14.8656L22.0399 14.7957C22.11 14.7722 22.1769 14.7426 22.235 14.6959C22.2973 14.6663 22.3497 14.6244 22.3921 14.5702C22.4629 14.5085 22.5173 14.4352 22.5525 14.3479C22.7616 13.9944 22.6941 13.3561 22.1809 13.0869C22.0909 13.0366 21.9969 12.9947 21.8995 12.9607C21.8088 12.9125 21.7153 12.8702 21.6181 12.8367C21.5043 12.7766 21.3866 12.7254 21.2662 12.6807C21.1105 12.605 20.9532 12.5325 20.7914 12.4707C20.6922 12.4266 20.593 12.3825 20.4939 12.3385C20.1852 12.2001 19.8764 12.0616 19.5675 11.9233C19.4365 11.8524 19.3053 11.7816 19.1742 11.711C19.08 11.6542 18.9858 11.5973 18.8917 11.5404C18.8437 11.4979 18.7885 11.466 18.7325 11.4355C18.7227 11.4289 18.7128 11.4222 18.7028 11.4157C18.6864 11.3834 18.6466 11.3875 18.6237 11.3656C18.6114 11.3352 18.5823 11.3263 18.5566 11.313C18.5254 11.2898 18.5045 11.2488 18.4557 11.2574C18.4231 11.2043 18.3585 11.1864 18.3216 11.138C18.2947 11.1084 18.2655 11.0815 18.2287 11.0643C18.194 11.0354 18.1593 11.0067 18.1244 10.9777C18.0953 10.957 18.0615 10.9421 18.0416 10.9102C18.0307 10.882 18.0059 10.8692 17.9816 10.8555C17.9441 10.8213 17.9065 10.7871 17.8692 10.753C17.8363 10.7226 17.8035 10.6925 17.7706 10.6621C17.7607 10.6341 17.7294 10.6313 17.7119 10.6123C17.7005 10.579 17.6727 10.5606 17.6466 10.5406C17.5962 10.4851 17.5503 10.4247 17.4854 10.3837C17.4546 10.349 17.424 10.3143 17.3932 10.2796C17.3923 10.2605 17.3784 10.2515 17.3641 10.2428C17.3512 10.22 17.3361 10.1998 17.3097 10.1912C17.2963 10.1742 17.2829 10.1572 17.2695 10.14C17.2692 10.1211 17.2556 10.1118 17.2417 10.1028C17.2107 10.0683 17.1797 10.0338 17.1487 9.99922C17.1455 9.96819 17.1168 9.96065 17.0978 9.94399C17.0881 9.92664 17.0783 9.90928 17.0686 9.89175C17.0568 9.86352 17.0379 9.84072 17.0138 9.82196C17.0057 9.78988 16.9773 9.7748 16.9559 9.75376C16.9469 9.70888 16.9122 9.68135 16.8845 9.64909C16.8701 9.61297 16.8435 9.5865 16.8151 9.56108C16.8157 9.52969 16.7908 9.51286 16.7746 9.49112C16.7575 9.46798 16.7405 9.44483 16.7234 9.42169C16.7149 9.38627 16.6908 9.36067 16.669 9.3335C16.6408 9.29265 16.6126 9.2518 16.5844 9.21077C16.5689 9.15642 16.537 9.11153 16.5016 9.06875C16.4833 9.04 16.465 9.01142 16.4467 8.98267C16.4409 8.94146 16.4182 8.90903 16.3926 8.87799C16.3653 8.8154 16.3384 8.75246 16.2908 8.70144C16.2833 8.68443 16.2755 8.66742 16.2679 8.65042C16.2628 8.60974 16.2426 8.57625 16.2181 8.54469C16.1998 8.51577 16.1815 8.48684 16.1631 8.45791C16.1684 8.42267 16.1443 8.39829 16.1306 8.37007C16.1277 8.32273 16.1038 8.28416 16.079 8.24611C16.0716 8.2149 16.0628 8.18422 16.0414 8.1588C16.0356 8.12759 16.0263 8.09778 16.0053 8.07271C15.9888 8.01625 15.9701 7.96085 15.9372 7.91123C15.934 7.8788 15.9227 7.84969 15.9013 7.82479C15.8956 7.79341 15.8863 7.76343 15.8653 7.73836C15.8653 7.72363 15.8625 7.71013 15.8497 7.70084C15.8482 7.68243 15.8463 7.66437 15.8298 7.6521C15.8276 7.62422 15.8157 7.6002 15.7991 7.57828C15.7914 7.56215 15.7836 7.54585 15.7759 7.52954C15.7597 7.48851 15.7435 7.44731 15.7271 7.40629C15.71 7.34492 15.6873 7.28583 15.6542 7.23113C15.641 7.17468 15.6186 7.1219 15.5886 7.07211C15.5805 7.05528 15.5724 7.03845 15.5643 7.02161C15.5524 6.9983 15.5402 6.97498 15.5282 6.95148C15.5362 6.91484 15.5184 6.88644 15.4985 6.85856C15.486 6.83103 15.4735 6.80368 15.461 6.77615C15.4368 6.73776 15.4465 6.68656 15.4138 6.65132C15.4007 6.6024 15.3822 6.55594 15.3551 6.51281C15.3331 6.4397 15.3051 6.36887 15.2674 6.30224C15.254 6.24613 15.2317 6.19354 15.2022 6.14409C15.182 6.07536 15.1547 6.00997 15.1115 5.95193C15.0777 5.87847 15.0305 5.81535 14.9664 5.76538C14.9009 5.69701 14.8329 5.63161 14.7399 5.60093C14.664 5.55394 14.5812 5.52764 14.4927 5.51782C14.4802 5.51256 14.4631 5.51501 14.4576 5.49766H14.2112C14.1984 5.5201 14.1751 5.51186 14.1563 5.51607C13.8312 5.59111 13.602 5.77678 13.4847 6.09185C13.4451 6.17092 13.4044 6.24947 13.3835 6.33625C13.3164 6.47319 13.2579 6.6138 13.2079 6.75774C13.142 6.8952 13.079 7.03371 13.0323 7.17888C12.9717 7.30354 12.9159 7.42995 12.8727 7.5618C12.807 7.69961 12.7415 7.83759 12.6966 7.98399C12.6142 8.16932 12.5316 8.35464 12.4492 8.53996C12.3563 8.71108 12.2635 8.88238 12.1707 9.0535C11.9617 9.39416 11.7308 9.71975 11.4814 10.0324C11.4139 10.0881 11.3671 10.1616 11.3121 10.228L10.9252 10.6309C10.8174 10.7291 10.7098 10.8275 10.602 10.9257C10.5483 10.959 10.4992 10.9977 10.4583 11.0463C10.4233 11.0605 10.3976 11.0864 10.3734 11.1141C10.2787 11.1706 10.1945 11.2409 10.1103 11.3114C10.0272 11.3691 9.94388 11.4267 9.86075 11.4844C9.80967 11.5049 9.76582 11.5365 9.7239 11.5714L9.49407 11.709C9.43542 11.7306 9.38347 11.7641 9.33292 11.8C9.25877 11.8258 9.1922 11.8659 9.12651 11.9079C9.05148 11.9347 8.98068 11.9703 8.91253 12.0111C8.83257 12.0392 8.75508 12.0723 8.68164 12.1147C8.62334 12.1365 8.56381 12.1556 8.51098 12.1896C8.45462 12.205 8.40284 12.2305 8.35265 12.2597C8.29629 12.2752 8.24416 12.3004 8.19396 12.3297C8.12369 12.36 8.05342 12.3904 7.98315 12.4207C7.91869 12.4494 7.85405 12.4782 7.7896 12.5069C7.72883 12.5301 7.66719 12.5513 7.61242 12.5874C7.54426 12.6078 7.48016 12.6369 7.41851 12.6719C7.33398 12.7038 7.24944 12.7352 7.17177 12.7824C7.12774 12.7922 7.08759 12.8103 7.0506 12.8359C6.98051 12.8527 6.91834 12.8872 6.85617 12.9216C6.80016 12.939 6.74539 12.9591 6.69643 12.9923C6.6406 13.007 6.58812 13.0296 6.53986 13.0615C6.44493 13.0947 6.36638 13.1529 6.29488 13.2216C5.94299 13.52 5.90125 14.1436 6.20946 14.4997C6.26829 14.5835 6.34349 14.6488 6.43331 14.6979C6.48174 14.7345 6.53334 14.7648 6.59322 14.7792C6.63144 14.8032 6.67142 14.8236 6.71615 14.8329C6.76564 14.8635 6.81813 14.8876 6.87448 14.9028C6.92538 14.9307 6.97452 14.9619 7.03281 14.9729C7.09833 15.0101 7.16596 15.0427 7.2387 15.0634C7.28783 15.0953 7.34085 15.1185 7.3972 15.1337C7.45937 15.1712 7.52542 15.2 7.59463 15.2214C7.64324 15.2522 7.6952 15.2754 7.7512 15.2899C7.81179 15.3297 7.8803 15.3525 7.94669 15.3795C7.99425 15.4141 8.05201 15.4258 8.10467 15.4491C8.15205 15.47 8.1996 15.4909 8.24697 15.5117C8.30192 15.5449 8.36004 15.5708 8.42256 15.5868C8.47188 15.6168 8.52383 15.641 8.57966 15.6564C8.65839 15.7007 8.74081 15.7365 8.82623 15.7658C8.87061 15.7944 8.91799 15.8165 8.96906 15.8305C9.00569 15.8557 9.04444 15.8759 9.08829 15.8855C9.15927 15.9217 9.23007 15.9579 9.30104 15.9941C9.33098 16.0097 9.3611 16.0253 9.39104 16.0411C9.46378 16.0884 9.53651 16.1357 9.6177 16.1682C9.6723 16.2095 9.72989 16.2464 9.79241 16.2751C9.80562 16.2919 9.82042 16.3063 9.84384 16.3067C9.87554 16.3372 9.91147 16.361 9.95233 16.3772C9.99865 16.4194 10.0506 16.4534 10.1066 16.4815C10.1638 16.5385 10.2304 16.5828 10.3007 16.6221C10.3195 16.6458 10.341 16.6657 10.3708 16.675C10.4194 16.7148 10.468 16.7546 10.5168 16.7943C10.5689 16.8367 10.6209 16.8789 10.673 16.9214C10.7 16.9533 10.729 16.9826 10.766 17.0031C10.8056 17.0388 10.8454 17.0746 10.8851 17.1104C10.9111 17.143 10.9368 17.1761 10.9742 17.1972C11.0731 17.2968 11.1723 17.3965 11.2713 17.4961C11.3828 17.6244 11.4942 17.753 11.6057 17.8813C11.7359 18.0559 11.8662 18.2306 11.9964 18.4052C12.1557 18.6531 12.3044 18.9075 12.4488 19.1642C12.5358 19.3497 12.6228 19.5354 12.7098 19.7208C12.7824 19.9179 12.8733 20.1069 12.9627 20.2966C13.0534 20.5239 13.1503 20.7485 13.2577 20.9685C13.3146 21.1223 13.381 21.272 13.4548 21.4186C13.4594 21.4724 13.4904 21.5166 13.5138 21.5618C13.6672 21.8576 13.9011 22.0412 14.2436 22.0678C14.3923 22.1002 14.5318 22.0639 14.669 22.0108C14.7709 21.9758 14.8613 21.9226 14.9354 21.8437C14.9826 21.8069 15.0252 21.7659 15.055 21.7133C15.0918 21.6747 15.124 21.6335 15.1306 21.5781C15.1415 21.5604 15.1524 21.5429 15.1631 21.5252C15.185 21.4996 15.1987 21.4706 15.1985 21.4363C15.2044 21.4256 15.2103 21.4149 15.2162 21.4042C15.235 21.383 15.2463 21.3584 15.2493 21.3304C15.2709 21.3128 15.2692 21.2872 15.2725 21.2634C15.2899 21.2282 15.3076 21.1929 15.325 21.1577C15.3486 21.121 15.369 21.083 15.3757 21.0391C15.4051 21.0079 15.4074 20.9645 15.4256 20.9282C15.4474 20.9033 15.4564 20.8728 15.4625 20.8412C15.4902 20.811 15.499 20.7725 15.5113 20.7353C15.5245 20.7006 15.5377 20.6659 15.5511 20.6313C15.5737 20.6134 15.582 20.5886 15.5862 20.5614C15.6145 20.5249 15.6276 20.4818 15.6402 20.4386C15.6491 20.4208 15.658 20.4029 15.6668 20.385C15.6917 20.3266 15.7163 20.2682 15.7412 20.2098C15.7641 20.1711 15.7859 20.132 15.7945 20.0873C15.8151 20.0615 15.8282 20.0329 15.8294 19.9996C15.8622 19.9575 15.8796 19.9083 15.8969 19.8588C15.9106 19.8199 15.9245 19.781 15.9382 19.7421C15.9539 19.7331 15.9636 19.7198 15.9662 19.7017C15.9747 19.6746 15.9831 19.6472 15.9914 19.62C16.0092 19.5901 16.0386 19.566 16.039 19.5273C16.0478 19.5047 16.0568 19.4819 16.0656 19.4593C16.0983 19.4314 16.111 19.394 16.1159 19.353C16.1392 19.3209 16.1598 19.2876 16.1675 19.248C16.1825 19.2241 16.1977 19.2003 16.2126 19.1763C16.2213 19.1535 16.2297 19.1307 16.2383 19.1081C16.254 19.0842 16.2697 19.0602 16.2854 19.0364C16.3009 19.0152 16.3202 18.9959 16.3201 18.9669C16.3361 18.9391 16.3585 18.9145 16.3625 18.8808C16.3766 18.8626 16.3907 18.8444 16.405 18.8261C16.4116 18.8144 16.4183 18.8028 16.425 18.7911C16.4384 18.7679 16.4518 18.7448 16.4652 18.7217C16.4719 18.7104 16.4786 18.6994 16.4851 18.6882C16.5154 18.6575 16.5355 18.6205 16.5522 18.5814C16.5913 18.5228 16.6302 18.4643 16.6693 18.4057C16.6845 18.3829 16.6996 18.3601 16.7147 18.3373C16.7371 18.318 16.7553 18.2958 16.7605 18.2656C16.7789 18.2423 16.7972 18.219 16.8155 18.1957C16.8456 18.155 16.8757 18.1145 16.9058 18.0738C16.9256 18.0619 16.937 18.0435 16.9453 18.0228C16.9636 18.0079 16.9807 17.9919 16.9865 17.9679C17.0156 17.9328 17.0446 17.8978 17.0735 17.8627C17.0888 17.8469 17.1091 17.8347 17.1115 17.8098C17.1476 17.7691 17.1839 17.7284 17.22 17.6879C17.2417 17.6756 17.2568 17.6574 17.2674 17.6353C17.2704 17.6255 17.2734 17.6159 17.2762 17.606C17.2991 17.5869 17.3331 17.5808 17.3445 17.5484C17.3542 17.5457 17.3599 17.5405 17.3574 17.5296C17.3826 17.501 17.4076 17.4723 17.4328 17.4437C17.4893 17.4081 17.5328 17.3593 17.5742 17.3082C17.6107 17.2724 17.6473 17.2366 17.6837 17.2007C17.7292 17.1716 17.7665 17.1339 17.8002 17.0923C17.8243 17.0809 17.8426 17.0634 17.8565 17.041C17.868 17.0306 17.8794 17.0201 17.8909 17.0097C18.1129 16.8323 18.335 16.6551 18.5571 16.4776C18.5957 16.4769 18.6188 16.4471 18.6466 16.4282C19.0189 16.175 19.4123 15.9604 19.8243 15.7782C20.1358 15.6404 20.4463 15.501 20.7572 15.3618Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
      <path
        d="M9.67815 5.77614C9.67445 5.75668 9.67744 5.73512 9.66106 5.71951C9.64468 5.65639 9.62549 5.5945 9.57512 5.54822C9.53708 5.48369 9.47878 5.44372 9.41168 5.41444C9.37399 5.37762 9.31675 5.38516 9.27589 5.35535C9.2139 5.31731 9.14715 5.29013 9.07829 5.26751C9.04271 5.24121 9.0022 5.22614 8.95976 5.21579C8.9145 5.17231 8.84194 5.18932 8.79791 5.14338C8.7655 5.11971 8.72904 5.10463 8.6903 5.09534C8.63077 5.058 8.56666 5.03012 8.50097 5.00557C8.43581 4.96981 8.37082 4.93386 8.30566 4.8981C8.25352 4.85567 8.19364 4.82569 8.13429 4.795C8.07494 4.75415 8.01541 4.7133 7.95606 4.67245C7.89636 4.62651 7.83648 4.5804 7.77677 4.53446C7.71566 4.48222 7.65455 4.42979 7.59343 4.37755C7.54958 4.33617 7.50572 4.29479 7.46205 4.25341C7.43721 4.23062 7.41238 4.20765 7.38755 4.18486C7.37469 4.14646 7.3407 4.12542 7.31464 4.09807C7.27325 4.05143 7.23186 4.0048 7.19047 3.95816C7.16247 3.92274 7.13464 3.8875 7.10664 3.85208C7.07758 3.81702 7.04835 3.78178 7.01929 3.74671C7.01312 3.69972 6.97649 3.67342 6.94761 3.64169C6.94074 3.60592 6.91502 3.58155 6.89442 3.55403C6.87645 3.5251 6.85831 3.49617 6.84035 3.46724C6.82274 3.43778 6.80513 3.40833 6.78734 3.37887C6.76779 3.32698 6.73873 3.28069 6.70245 3.23879C6.70245 3.20425 6.68149 3.17865 6.66458 3.1513C6.64909 3.12149 6.63359 3.09186 6.61809 3.06205C6.59026 2.97667 6.55187 2.89567 6.50995 2.81642C6.47948 2.73173 6.45377 2.64512 6.40604 2.56745C6.39724 2.51853 6.37593 2.47488 6.35074 2.43262C6.33965 2.40913 6.32855 2.38581 6.31746 2.36232C6.30002 2.2736 6.25916 2.19751 6.19206 2.13597C6.14222 2.07215 6.07635 2.03358 5.99833 2.01446C5.73486 1.96116 5.5443 2.02306 5.43598 2.21048C5.36078 2.34058 5.30548 2.48119 5.25934 2.62478C5.19946 2.74471 5.14609 2.86744 5.10171 2.99385C5.03655 3.12114 4.97121 3.24843 4.90604 3.37572C4.86642 3.43112 4.82609 3.486 4.79949 3.54947C4.74683 3.62556 4.69417 3.70148 4.64151 3.77757C4.51929 3.91924 4.39706 4.06108 4.27483 4.20274C4.12232 4.34932 3.96698 4.49256 3.79879 4.62125C3.71636 4.67981 3.63394 4.73837 3.55152 4.79711C3.47068 4.83691 3.39283 4.88162 3.32133 4.93667C3.1512 5.0182 2.98107 5.09972 2.81094 5.18125C2.69047 5.22526 2.57265 5.27523 2.45958 5.33589C2.3791 5.36167 2.3016 5.3941 2.23186 5.44267C2.17462 5.4595 2.14486 5.50771 2.10981 5.54979C2.06684 5.60134 2.03549 5.6585 2.02439 5.72547C2.0059 5.77071 1.99991 5.8177 2.00661 5.86609C1.99991 5.92324 2.00414 5.97847 2.03672 6.02844C2.04747 6.10488 2.09026 6.16239 2.14662 6.21183C2.18484 6.25462 2.22675 6.29196 2.28382 6.30827C2.33929 6.34386 2.39988 6.36823 2.46222 6.38909C2.57565 6.45063 2.69453 6.4999 2.81499 6.54584C2.94391 6.6044 3.07283 6.66296 3.20175 6.72169C3.312 6.78306 3.42207 6.84442 3.53232 6.90596C3.60911 6.95716 3.6859 7.00835 3.76268 7.05955C3.83894 7.11828 3.91538 7.17685 3.99164 7.23558C4.05064 7.2873 4.10946 7.33902 4.16828 7.39075C4.22094 7.44334 4.27378 7.49594 4.32644 7.54872C4.3481 7.58554 4.38068 7.61183 4.41344 7.63813C4.44409 7.68284 4.47209 7.72983 4.51911 7.76069C4.55363 7.80277 4.58815 7.84467 4.62267 7.88675C4.65102 7.94251 4.69347 7.98792 4.73274 8.0356C4.76163 8.07733 4.79033 8.11924 4.81922 8.16096C4.8525 8.21426 4.88561 8.26739 4.9189 8.32069C4.94902 8.37311 4.97896 8.42554 5.00907 8.47813C5.02668 8.52775 5.04976 8.57474 5.08181 8.61699C5.09784 8.6731 5.12425 8.72465 5.15472 8.77409C5.17674 8.84177 5.20368 8.90751 5.24102 8.96835C5.2574 9.02411 5.27801 9.07828 5.31041 9.12703C5.32644 9.18313 5.34757 9.23696 5.38015 9.28605C5.39266 9.33742 5.41379 9.38423 5.45095 9.42298C5.49093 9.49644 5.55187 9.54571 5.62883 9.57674C5.87293 9.70386 6.17198 9.60006 6.27941 9.35109C6.32679 9.27535 6.35462 9.19102 6.38614 9.10844C6.43035 9.03007 6.46592 8.94819 6.4941 8.8628C6.53408 8.80424 6.55328 8.73639 6.58058 8.67222C6.6269 8.58333 6.67304 8.49462 6.71936 8.40572C6.7847 8.30105 6.85004 8.19638 6.91538 8.09171C6.99058 7.99212 7.06596 7.89253 7.14116 7.79295C7.2729 7.65374 7.40481 7.51453 7.53655 7.37532C7.64539 7.28748 7.75264 7.19771 7.86342 7.11232C8.09784 6.93173 8.35691 6.79095 8.62073 6.65857C8.88579 6.54233 9.15278 6.43012 9.4152 6.30809C9.56878 6.23673 9.65402 6.10664 9.67868 5.93902L9.68607 5.93955L9.69294 5.93657V5.77895C9.68801 5.77737 9.68325 5.77597 9.67815 5.77614Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const RadioButtonUnchecked = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const CheckLine = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M10.5922 13.8L8.44219 11.65C8.25885 11.4667 8.02552 11.375 7.74219 11.375C7.45885 11.375 7.22552 11.4667 7.04219 11.65C6.85885 11.8333 6.76719 12.0667 6.76719 12.35C6.76719 12.6333 6.85885 12.8667 7.04219 13.05L9.89219 15.9C10.0922 16.1 10.3255 16.2 10.5922 16.2C10.8589 16.2 11.0922 16.1 11.2922 15.9L16.9422 10.25C17.1255 10.0667 17.2172 9.83333 17.2172 9.55C17.2172 9.26667 17.1255 9.03333 16.9422 8.85C16.7589 8.66667 16.5255 8.575 16.2422 8.575C15.9589 8.575 15.7255 8.66667 15.5422 8.85L10.5922 13.8ZM11.9922 22C10.6089 22 9.30885 21.7375 8.09219 21.2125C6.87552 20.6875 5.81719 19.975 4.91719 19.075C4.01719 18.175 3.30469 17.1167 2.77969 15.9C2.25469 14.6833 1.99219 13.3833 1.99219 12C1.99219 10.6167 2.25469 9.31667 2.77969 8.1C3.30469 6.88333 4.01719 5.825 4.91719 4.925C5.81719 4.025 6.87552 3.3125 8.09219 2.7875C9.30885 2.2625 10.6089 2 11.9922 2C13.3755 2 14.6755 2.2625 15.8922 2.7875C17.1089 3.3125 18.1672 4.025 19.0672 4.925C19.9672 5.825 20.6797 6.88333 21.2047 8.1C21.7297 9.31667 21.9922 10.6167 21.9922 12C21.9922 13.3833 21.7297 14.6833 21.2047 15.9C20.6797 17.1167 19.9672 18.175 19.0672 19.075C18.1672 19.975 17.1089 20.6875 15.8922 21.2125C14.6755 21.7375 13.3755 22 11.9922 22ZM11.9922 20C14.2255 20 16.1172 19.225 17.6672 17.675C19.2172 16.125 19.9922 14.2333 19.9922 12C19.9922 9.76667 19.2172 7.875 17.6672 6.325C16.1172 4.775 14.2255 4 11.9922 4C9.75885 4 7.86719 4.775 6.31719 6.325C4.76719 7.875 3.99219 9.76667 3.99219 12C3.99219 14.2333 4.76719 16.125 6.31719 17.675C7.86719 19.225 9.75885 20 11.9922 20Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const CheckFill = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};
const AddCircle = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M11 13V16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16V13H16C16.2833 13 16.5208 12.9042 16.7125 12.7125C16.9042 12.5208 17 12.2833 17 12C17 11.7167 16.9042 11.4792 16.7125 11.2875C16.5208 11.0958 16.2833 11 16 11H13V8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8V11H8C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13H11ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Autorenew = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M6 12.0508C6 12.3174 6.01667 12.5799 6.05 12.8383C6.08333 13.0966 6.14167 13.3508 6.225 13.6008C6.30833 13.8841 6.3 14.1549 6.2 14.4133C6.1 14.6716 5.925 14.8591 5.675 14.9758C5.40833 15.1091 5.14583 15.1216 4.8875 15.0133C4.62917 14.9049 4.45833 14.7091 4.375 14.4258C4.24167 14.0424 4.14583 13.6508 4.0875 13.2508C4.02917 12.8508 4 12.4508 4 12.0508C4 9.81745 4.775 7.91745 6.325 6.35078C7.875 4.78411 9.76667 4.00078 12 4.00078H12.175L11.275 3.10078C11.0917 2.91745 11 2.68411 11 2.40078C11 2.11745 11.0917 1.88411 11.275 1.70078C11.4583 1.51745 11.6917 1.42578 11.975 1.42578C12.2583 1.42578 12.4917 1.51745 12.675 1.70078L15.275 4.30078C15.475 4.50078 15.575 4.73411 15.575 5.00078C15.575 5.26745 15.475 5.50078 15.275 5.70078L12.675 8.30078C12.4917 8.48411 12.2583 8.57578 11.975 8.57578C11.6917 8.57578 11.4583 8.48411 11.275 8.30078C11.0917 8.11745 11 7.88411 11 7.60078C11 7.31745 11.0917 7.08411 11.275 6.90078L12.175 6.00078H12C10.3333 6.00078 8.91667 6.58828 7.75 7.76328C6.58333 8.93828 6 10.3674 6 12.0508ZM18 11.9508C18 11.6841 17.9833 11.4216 17.95 11.1633C17.9167 10.9049 17.8583 10.6508 17.775 10.4008C17.6917 10.1174 17.7 9.84661 17.8 9.58828C17.9 9.32995 18.075 9.14245 18.325 9.02578C18.5917 8.89245 18.8542 8.87995 19.1125 8.98828C19.3708 9.09661 19.5417 9.29245 19.625 9.57578C19.7583 9.95912 19.8542 10.3508 19.9125 10.7508C19.9708 11.1508 20 11.5508 20 11.9508C20 14.1841 19.225 16.0841 17.675 17.6508C16.125 19.2174 14.2333 20.0008 12 20.0008H11.825L12.725 20.9008C12.9083 21.0841 13 21.3174 13 21.6008C13 21.8841 12.9083 22.1174 12.725 22.3008C12.5417 22.4841 12.3083 22.5758 12.025 22.5758C11.7417 22.5758 11.5083 22.4841 11.325 22.3008L8.725 19.7008C8.525 19.5008 8.425 19.2674 8.425 19.0008C8.425 18.7341 8.525 18.5008 8.725 18.3008L11.325 15.7008C11.5083 15.5174 11.7417 15.4258 12.025 15.4258C12.3083 15.4258 12.5417 15.5174 12.725 15.7008C12.9083 15.8841 13 16.1174 13 16.4008C13 16.6841 12.9083 16.9174 12.725 17.1008L11.825 18.0008H12C13.6667 18.0008 15.0833 17.4133 16.25 16.2383C17.4167 15.0633 18 13.6341 18 11.9508Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const AddNoti = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 8.96992V12.543C17.7042 12.3739 17.3617 12.2773 16.9967 12.2773C15.8783 12.2773 14.9717 13.184 14.9717 14.3023V15.1256H14.1461C13.0277 15.1256 12.1211 16.0322 12.1211 17.1506C12.1211 18.269 13.0277 19.1756 14.1461 19.1756H14.4076C14.1129 20.2281 13.1466 21 12 21C10.6193 21 9.5 19.8807 9.5 18.5H8.5L7.49756 18.4961H5.49512C4.94328 18.4956 4.49609 18.0481 4.49609 17.4961C4.49609 16.9441 4.94426 16.4966 5.49609 16.4961H6V8.96992C6 7.58197 6.41667 6.34869 7.25 5.2701C8.08333 4.1915 9.4 3.35111 10.5 3.15054C11.6 2.94996 12.4 2.94968 13.5 3.15054C14.6 3.35139 15.9167 4.1915 16.75 5.2701C17.5833 6.34869 18 7.58197 18 8.96992ZM16.3232 14.3039C16.3232 13.9311 16.6255 13.6289 16.9982 13.6289C17.371 13.6289 17.6732 13.9311 17.6732 14.3039V16.4771H19.8477C20.2204 16.4771 20.5227 16.7794 20.5227 17.1521C20.5227 17.5249 20.2204 17.8271 19.8477 17.8271H17.6732V20.0039C17.6732 20.3767 17.371 20.6789 16.9982 20.6789C16.6255 20.6789 16.3232 20.3767 16.3232 20.0039V17.8271H14.1477C13.7749 17.8271 13.4727 17.5249 13.4727 17.1521C13.4727 16.7794 13.7749 16.4771 14.1477 16.4771H16.3232V14.3039Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Secure = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M12 11.25C11.4844 11.25 11.043 11.0664 10.6758 10.6992C10.3086 10.332 10.125 9.89062 10.125 9.375C10.125 8.85938 10.3086 8.41797 10.6758 8.05078C11.043 7.68359 11.4844 7.5 12 7.5C12.5156 7.5 12.957 7.68359 13.3242 8.05078C13.6914 8.41797 13.875 8.85938 13.875 9.375C13.875 9.89062 13.6914 10.332 13.3242 10.6992C12.957 11.0664 12.5156 11.25 12 11.25ZM9.05 15C8.60817 15 8.25 14.6418 8.25 14.2V13.6875C8.25 13.4219 8.31836 13.1777 8.45508 12.9551C8.5918 12.7324 8.77344 12.5625 9 12.4453C9.48438 12.2031 9.97656 12.0215 10.4766 11.9004C10.9766 11.7793 11.4844 11.7188 12 11.7188C12.5156 11.7188 13.0234 11.7793 13.5234 11.9004C14.0234 12.0215 14.5156 12.2031 15 12.4453C15.2266 12.5625 15.4082 12.7324 15.5449 12.9551C15.6816 13.1777 15.75 13.4219 15.75 13.6875V14.2C15.75 14.6418 15.3918 15 14.95 15H9.05Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.54097 4.65298C4.92488 4.85835 4.51956 5.44725 4.54777 6.09606L4.96932 15.7916C4.98875 16.2387 5.2129 16.6519 5.57705 16.912L11.1547 20.896C11.6604 21.2573 12.3398 21.2573 12.8456 20.896L18.4232 16.912C18.7873 16.6519 19.0115 16.2387 19.0309 15.7916L19.4525 6.09606C19.4807 5.44725 19.0754 4.85835 18.4593 4.65298L12.4601 2.65326C12.1615 2.55373 11.8387 2.55373 11.5401 2.65326L5.54097 4.65298ZM10.6759 10.6992C11.0431 11.0663 11.4845 11.2499 12.0001 11.2499C12.5157 11.2499 12.9571 11.0663 13.3243 10.6992C13.6915 10.332 13.8751 9.89056 13.8751 9.37493C13.8751 8.85931 13.6915 8.4179 13.3243 8.05071C12.9571 7.68353 12.5157 7.49993 12.0001 7.49993C11.4845 7.49993 11.0431 7.68353 10.6759 8.05071C10.3087 8.4179 10.1251 8.85931 10.1251 9.37493C10.1251 9.89056 10.3087 10.332 10.6759 10.6992ZM8.25011 14.1999C8.25011 14.6418 8.60829 14.9999 9.05011 14.9999H14.9501C15.3919 14.9999 15.7501 14.6418 15.7501 14.1999V13.6874C15.7501 13.4218 15.6818 13.1777 15.545 12.955C15.4083 12.7324 15.2267 12.5624 15.0001 12.4452C14.5157 12.2031 14.0236 12.0214 13.5236 11.9003C13.0236 11.7792 12.5157 11.7187 12.0001 11.7187C11.4845 11.7187 10.9767 11.7792 10.4767 11.9003C9.97668 12.0214 9.48449 12.2031 9.00011 12.4452C8.77355 12.5624 8.59191 12.7324 8.45519 12.955C8.31847 13.1777 8.25011 13.4218 8.25011 13.6874V14.1999Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Add = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 20 20"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M8.75 10.8333H3.54167C3.24653 10.8333 2.99913 10.7335 2.79948 10.5339C2.59983 10.3342 2.5 10.0868 2.5 9.79167C2.5 9.49653 2.59983 9.24913 2.79948 9.04948C2.99913 8.84983 3.24653 8.75 3.54167 8.75H8.75V3.54167C8.75 3.24653 8.84983 2.99913 9.04948 2.79948C9.24913 2.59983 9.49653 2.5 9.79167 2.5C10.0868 2.5 10.3342 2.59983 10.5339 2.79948C10.7335 2.99913 10.8333 3.24653 10.8333 3.54167V8.75H16.0417C16.3368 8.75 16.5842 8.84983 16.7839 9.04948C16.9835 9.24913 17.0833 9.49653 17.0833 9.79167C17.0833 10.0868 16.9835 10.3342 16.7839 10.5339C16.5842 10.7335 16.3368 10.8333 16.0417 10.8333H10.8333V16.0417C10.8333 16.3368 10.7335 16.5842 10.5339 16.7839C10.3342 16.9835 10.0868 17.0833 9.79167 17.0833C9.49653 17.0833 9.24913 16.9835 9.04948 16.7839C8.84983 16.5842 8.75 16.3368 8.75 16.0417V10.8333Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};
const Portfolio = ({ width, height }: { width?: number; height?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="5.60156"
        y="4"
        width="11.2"
        height="14.4"
        rx="0.5"
        fill="#75A7FF"
      />
      <path
        d="M8.50195 7.5C8.50195 7.22386 8.72581 7 9.00195 7L19.002 7C19.2781 7 19.502 7.22386 19.502 7.5V17L15.502 21H9.00195C8.72581 21 8.50195 20.7761 8.50195 20.5V7.5Z"
        fill="#1A6DFF"
      />
      <path
        d="M15.502 17.4C15.502 17.1791 15.681 17 15.902 17H19.502L17.502 19L15.502 21V17.4Z"
        fill="#7AADFF"
      />
    </svg>
  );
};
const Setting = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 17 16"
      className={ICON_FILL[fill] || ""}
    >
      <path
        d="M7.46763 14.6673C7.16763 14.6673 6.9093 14.5673 6.69263 14.3673C6.47596 14.1673 6.34541 13.9229 6.30096 13.634L6.15096 12.534C6.00652 12.4784 5.87041 12.4118 5.74263 12.334C5.61485 12.2562 5.48985 12.1729 5.36763 12.084L4.3343 12.5173C4.05652 12.6395 3.77874 12.6507 3.50096 12.5507C3.22319 12.4507 3.00652 12.2729 2.85096 12.0173L2.06763 10.6507C1.91207 10.3951 1.86763 10.1229 1.9343 9.83398C2.00096 9.5451 2.15096 9.30621 2.3843 9.11732L3.26763 8.45065C3.25652 8.37287 3.25096 8.29787 3.25096 8.22565V7.77565C3.25096 7.70343 3.25652 7.62843 3.26763 7.55065L2.3843 6.88398C2.15096 6.6951 2.00096 6.45621 1.9343 6.16732C1.86763 5.87843 1.91207 5.60621 2.06763 5.35065L2.85096 3.98398C3.00652 3.72843 3.22319 3.55065 3.50096 3.45065C3.77874 3.35065 4.05652 3.36176 4.3343 3.48398L5.36763 3.91732C5.48985 3.82843 5.61763 3.7451 5.75096 3.66732C5.8843 3.58954 6.01763 3.52287 6.15096 3.46732L6.30096 2.36732C6.34541 2.07843 6.47596 1.83398 6.69263 1.63398C6.9093 1.43398 7.16763 1.33398 7.46763 1.33398H9.0343C9.3343 1.33398 9.59263 1.43398 9.8093 1.63398C10.026 1.83398 10.1565 2.07843 10.201 2.36732L10.351 3.46732C10.4954 3.52287 10.6315 3.58954 10.7593 3.66732C10.8871 3.7451 11.0121 3.82843 11.1343 3.91732L12.1676 3.48398C12.4454 3.36176 12.7232 3.35065 13.001 3.45065C13.2787 3.55065 13.4954 3.72843 13.651 3.98398L14.4343 5.35065C14.5899 5.60621 14.6343 5.87843 14.5676 6.16732C14.501 6.45621 14.351 6.6951 14.1176 6.88398L13.2343 7.55065C13.2454 7.62843 13.251 7.70343 13.251 7.77565V8.22565C13.251 8.29787 13.2399 8.37287 13.2176 8.45065L14.101 9.11732C14.3343 9.30621 14.4843 9.5451 14.551 9.83398C14.6176 10.1229 14.5732 10.3951 14.4176 10.6507L13.6176 12.0173C13.4621 12.2729 13.2454 12.4507 12.9676 12.5507C12.6899 12.6507 12.4121 12.6395 12.1343 12.5173L11.1343 12.084C11.0121 12.1729 10.8843 12.2562 10.751 12.334C10.6176 12.4118 10.4843 12.4784 10.351 12.534L10.201 13.634C10.1565 13.9229 10.026 14.1673 9.8093 14.3673C9.59263 14.5673 9.3343 14.6673 9.0343 14.6673H7.46763ZM8.2843 10.334C8.92874 10.334 9.47874 10.1062 9.9343 9.65065C10.3899 9.1951 10.6176 8.6451 10.6176 8.00065C10.6176 7.35621 10.3899 6.80621 9.9343 6.35065C9.47874 5.8951 8.92874 5.66732 8.2843 5.66732C7.62874 5.66732 7.07596 5.8951 6.62596 6.35065C6.17596 6.80621 5.95096 7.35621 5.95096 8.00065C5.95096 8.6451 6.17596 9.1951 6.62596 9.65065C7.07596 10.1062 7.62874 10.334 8.2843 10.334Z"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const Circle = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "10"}
      height={height ? height : "10"}
      viewBox="0 0 10 10"
      className={ICON_FILL[fill] || ""}
    >
      <circle
        cx="5"
        cy="5"
        r="3"
        fill={ICON_FILL[fill] ? "currentColor" : fill}
      />
    </svg>
  );
};

const ContentCopy = ({
  fill,
  width,
  height,
}: {
  fill: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "10"}
      height={height ? height : "10"}
      viewBox="0 0 16 16"
      fill="none"
      className={ICON_FILL[fill] || ""}
    >
      <mask
        id="mask0_17207_12399"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17207_12399)">
        <path
          d="M6 12.0007C5.63333 12.0007 5.31944 11.8701 5.05833 11.609C4.79722 11.3479 4.66667 11.034 4.66667 10.6673V2.66732C4.66667 2.30065 4.79722 1.98676 5.05833 1.72565C5.31944 1.46454 5.63333 1.33398 6 1.33398H12C12.3667 1.33398 12.6806 1.46454 12.9417 1.72565C13.2028 1.98676 13.3333 2.30065 13.3333 2.66732V10.6673C13.3333 11.034 13.2028 11.3479 12.9417 11.609C12.6806 11.8701 12.3667 12.0007 12 12.0007H6ZM6 10.6673H12V2.66732H6V10.6673ZM3.33333 14.6673C2.96667 14.6673 2.65278 14.5368 2.39167 14.2757C2.13056 14.0145 2 13.7007 2 13.334V4.66732C2 4.47843 2.06389 4.3201 2.19167 4.19232C2.31944 4.06454 2.47778 4.00065 2.66667 4.00065C2.85556 4.00065 3.01389 4.06454 3.14167 4.19232C3.26944 4.3201 3.33333 4.47843 3.33333 4.66732V13.334H10C10.1889 13.334 10.3472 13.3979 10.475 13.5257C10.6028 13.6534 10.6667 13.8118 10.6667 14.0007C10.6667 14.1895 10.6028 14.3479 10.475 14.4756C10.3472 14.6034 10.1889 14.6673 10 14.6673H3.33333Z"
          fill={ICON_FILL[fill] ? "currentColor" : fill}
        />
      </g>
    </svg>
  );
};

const Icon = ({
  name,
  fill,
  height,
  width,
}: {
  name: string;
  fill: string;
  height?: number;
  width?: number;
}) => {
  const props = { fill, height, width };
  switch (name) {
    case ICONS.LOGO:
      return <Logo {...props} />;
    case ICONS.PLUS:
      return <Plus {...props} />;
    case ICONS.OPTIONS:
      return <Options {...props} />;
    case ICONS.SHARE:
      return <Share {...props} />;
    case ICONS.HELPLINE:
      return <HelpLine {...props} />;
    case ICONS.NOTI_OFF:
      return <NotiOff {...props} />;
    case ICONS.WORST_CASE:
      return <WorstCase {...props} />;
    case ICONS.CLOSE:
      return <Close {...props} />;
    case ICONS.SEARCH:
      return <Search {...props} />;
    case ICONS.MENU:
      return <Menu {...props} />;
    case ICONS.HOME:
      return <Home {...props} />;
    case ICONS.BEST_CASE:
      return <BestCase {...props} />;
    case ICONS.GRADE:
      return <Grade {...props} />;
    case ICONS.NOTI_ON:
      return <NotiOn {...props} />;
    case ICONS.PIE_CHART:
      return <PieChart {...props} />;
    case ICONS.ARROW_FORWARD:
      return <ArrowForward {...props} />;
    case ICONS.LINE:
      return <Line {...props} />;
    case ICONS.BACK:
      return <Back {...props} />;
    case ICONS.FORWARD:
      return <Forward {...props} />;
    case ICONS.EXPAND:
      return <Expand {...props} />;
    case ICONS.COLLAPSE:
      return <Collapse {...props} />;
    case ICONS.CANDLE:
      return <Candle {...props} />;
    case ICONS.UP:
      return <Up {...props} />;
    case ICONS.DOWN:
      return <Down {...props} />;
    case ICONS.EXPAND_ALL:
      return <ExpandAll {...props} />;
    case ICONS.CHECK:
      return <Check {...props} />;
    case ICONS.CANCEL:
      return <Cancel {...props} />;
    case ICONS.TEXT_VALUE:
      return <TextValue {...props} />;
    case ICONS.RADIO_BUTTON_CHECKED:
      return <RadioButtonChecked {...props} />;
    case ICONS.RADIO_BUTTON_UNCHECKED:
      return <RadioButtonUnchecked {...props} />;
    case ICONS.AI:
      return <Ai {...props} />;
    case ICONS.HELP:
      return <Help {...props} />;
    case ICONS.CHECK_LINE:
      return <CheckLine {...props} />;
    case ICONS.CHECK_FILL:
      return <CheckFill {...props} />;
    case ICONS.ADD_CIRCLE:
      return <AddCircle {...props} />;
    case ICONS.AUTORENEW:
      return <Autorenew {...props} />;
    case ICONS.ADD_NOTI:
      return <AddNoti {...props} />;
    case ICONS.SECURE:
      return <Secure {...props} />;
    case ICONS.ADD:
      return <Add {...props} />;
    case ICONS.PORTFOLIO:
      return <Portfolio {...props} />;
    case ICONS.SETTING:
      return <Setting {...props} />;
    case ICONS.CIRCLE:
      return <Circle {...props} />;
    case ICONS.CONTENT_COPY:
      return <ContentCopy {...props} />;
    default:
      return null;
  }
};

//이 페이지에서 선언된 svg 아이콘들을 사용할 수 있도록 export
export {
  Logo,
  Plus,
  Options,
  Share,
  HelpLine,
  NotiOff,
  WorstCase,
  Close,
  Search,
  Menu,
  Home,
  BestCase,
  Grade,
  NotiOn,
  PieChart,
  ArrowForward,
  Line,
  Back,
  Forward,
  Expand,
  Collapse,
  Candle,
  Up,
  Down,
  ExpandAll,
  Check,
  Cancel,
  TextValue,
  RadioButtonChecked,
  RadioButtonUnchecked,
  Ai,
  Help,
  CheckLine,
  CheckFill,
  AddCircle,
  Autorenew,
  AddNoti,
  Secure,
  Add,
  Portfolio,
  Setting,
  Circle,
  ContentCopy,
};

export default Icon;
